import {
    ChangeEvent, DataSource, DataSourceExecutionEvent, DataSourceMode, DataSourceModeChangeEvent,
    LookupModelSelectionEvent, ModelDataChangeType, Textbox
} from "@mcleod/components";
import { ModelRow, StringUtil } from "@mcleod/core";
import { OrderHandlingRequirementsSlideout } from "../OrderHandlingRequirementsSlideout";
import { AutogenLayoutQuoteEntryLTL } from "./autogen/AutogenLayoutQuoteEntryLTL";

export class QuoteEntryLTL extends AutogenLayoutQuoteEntryLTL {
    override onLoad() {
        this.mainDataSource.doBeforeDataSourcePost = async () => {
            if (this.mainDataSource.mode == DataSourceMode.ADD) {
                if (this.layoutFreightItems.mainDataSource.data.length === 1 && !this.layoutFreightItems.mainDataSource.validateSimple()) {
                    this.layoutFreightItems.tableFreightItems.removeRow(0);
                }
            }
            return true;
        }

        this.setupContactListeners();
        this.layoutQuoteStopTable.shipperPONumLayout = this.layoutShipperPONums;
        this.layoutFreightItems.doBeforeCommoditySearch = (filter: any) => {
            filter.product_book_location = this.sourceQuoteStop?.data?.[0].get("location_id");
            filter.product_book_customer = this.activeRow.get("customer_id");
        };
    }

    /** This is an event handler for the afterModeChange event of sourceQuoteFreightGroupItem.  */
    sourceQuoteFreightGroupItemAfterModeChange(event: DataSourceModeChangeEvent) {
        if (event.newMode === DataSourceMode.ADD)
            this.layoutFreightItems.addFreightItemToTable();
    }

    imageAddHandlingReqOnClick() {
        OrderHandlingRequirementsSlideout.showSlideout({
            hdrDataSource: this.sourceQuoteHdrXFgp,
            hdrChanged: (row: ModelRow, type: ModelDataChangeType) => this.hdrChanged(row, type),
            onSave: (hasChanged: boolean) => {
                this.layoutHandlingReqs.populateHdrs(this.sourceQuoteHdrXFgp.data, true, hasChanged).then(() => {
                    this.sourceQuoteHdrXFgp.notifyHasChangedComponents(true);
                });
            },
            invokedFromEdi: false
        })
    }

    hdrChanged(hdr: ModelRow<any>, type: ModelDataChangeType) {
        if (type == ModelDataChangeType.ADD) {
            hdr.set("fgp_uid", this.mainDataSource.activeRow.get("fgp_uid"));
            hdr.set("order_id", this.mainDataSource.activeRow.get("id"));
            hdr._appending = true;
            this.sourceQuoteHdrXFgp.addRow(hdr, this.sourceQuoteHdrXFgp.data.length, false);
        }
        else if (type == ModelDataChangeType.DELETE) {
            this.sourceQuoteHdrXFgp.data.forEach(row => {
                if (row?.data["hdr_uid"] == hdr?.data["hdr_uid"]) {
                    this.sourceQuoteHdrXFgp._deleteTableRow(row, true);
                    return;
                }
            });
        }
        else if (type == ModelDataChangeType.UPDATE) {
            this.sourceQuoteHdrXFgp.data.forEach((row, index) => {
                if (row?.data["hdr_uid"] == hdr?.data["hdr_uid"]) {
                    row.setValues({
                        "text_value": hdr.data["text_value"],
                        "integer_value": hdr.data["integer_value"],
                        "float_value": hdr.data["float_value"],
                        "time_value": hdr.data["time_value"],
                        "date_value": hdr.data["date_value"]
                    });
                }
            });
        }

    }

    setupContactListeners() {
        this.textboxCustomerName.addLookupModelSelectionListener((event: LookupModelSelectionEvent) => {
            if (event.hasSelection() === true) {
                const selectedRow = event.selection;
                if (!selectedRow.isNull("id"))
                    this.activeRow.set("customer_id", selectedRow.get("id"));
            }
        });
        this.textboxCustomerName.addChangeListener((event: ChangeEvent) => this.customerOnChange(event));
        this.textboxCustomerName.addDataDisplayListener(event => this.setCustomerNameTooltip());
        this.textboxCustomerName.addBeforeLookupModelSearchListener(event => this.textboxCustomerNameBeforeLookupModelSearch(event));
        this.textboxCustomerContactName.addBeforeLookupModelSearchListener(event => this.textboxCustomerContactNameBeforeLookupModelSearch(event));
    }

    customerOnChange(event: ChangeEvent) {
        this.setCustomerNameTooltip();
        if (StringUtil.isEmptyString(event.newValue)) {
            this.activeRow.set({ customer_id: null, customer_name: null });
            this.clearCustomerContactInfo();
        }
    }

    setCustomerNameTooltip() {
        const lookupModelData = this.textboxCustomerName.getFirstLookupModelData();
        this.textboxCustomerName.quickInfoOverrideKeyValue = lookupModelData?.get("id");
    }

    textboxCustomerNameBeforeLookupModelSearch(event) {
        event.filter.is_customer = "Y";
    }

    /** This is an event handler for the beforeLookupModelSearch event of textboxCustomerContactName.  */
    textboxCustomerContactNameBeforeLookupModelSearch(event) {
        const contactName = event.target as Textbox;
        if (this.activeRow.isNull("customer_id")) {
            event.preventDefault();
        } else {
            event.filter.parent_row_id = this.activeRow.get("customer_id");
            event.filter.parent_row_type = "C";
            event.filter.is_active = "Y";
        }

        if (contactName != null)
            contactName.addLookupModelSelectionListener((event: LookupModelSelectionEvent) => {
                const selectedRow = event.selection;
                if (selectedRow != null) {
                    this.activeRow.set("customer_phone", selectedRow.get("phone"));
                    this.activeRow.set("customer_email", selectedRow.get("email"));
                }
            });
    }

    private clearCustomerContactInfo() {
        this.activeRow.set("customer_contact_name", null);
        this.activeRow.set("customer_phone", null);
        this.activeRow.set("customer_email", null);
        this.textboxCustomerContactName.clear();
    }

    /** This is an event handler for the afterExecution event of sourceQuoteHdrXFgp.  */
    sourceQuoteHdrXFgpAfterExecution(event: DataSourceExecutionEvent) {
        this.layoutHandlingReqs.populateHdrs(event.dataSource.data, true);
    }

    getFreightGroupItemDataSource(): DataSource {
        return this.sourceQuoteFreightGroupItem;
    }

    getStopDataSource(): DataSource {
        return this.sourceQuoteStop;
    }

    getHdrXFgpDataSource(): DataSource {
        return this.sourceQuoteHdrXFgp;
    }

    getBillingFreightGroupDataSource(): DataSource {
        return this.mainDataSource.childDataSources.find(ds => ds.id === "sourceQuoteBrltlBillingFreightGroup");
    }
}
